import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import * as style from './SVGDefs.module.scss'

const SVGDefs = (props) => {
  const { className, ...rest } = props

  return (
    <svg
      {...rest}
      className={classNames(style.svgDefs, className)}
      aria-hidden="true"
      focusable="false"
      tabIndex={-1}
    >
      <symbol
        id="icon-logo-short"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 153 49.8"
        xmlSpace="preserve"
      >
        <g fill="#FFF">
          <path d="M64 43.9a15 15 0 0 1-7.7-1.9 15 15 0 0 1-5.3-5.3 15 15 0 0 1-1.9-7.7c0-2.8.5-5.7 1.5-8.3.9-2.5 2.3-4.7 4.1-6.7a19.1 19.1 0 0 1 14-6c2.7-.1 5.4.6 7.7 1.9 2.2 1.3 4 3.1 5.2 5.4 1.3 2.5 1.9 5.3 1.9 8.1h-8.7a9 9 0 0 0-1-4.2c-.5-1.1-1.3-2-2.4-2.6a7.4 7.4 0 0 0-3.6-.9c-1.4 0-2.7.3-3.9 1-1.2.7-2.2 1.6-3.1 2.7a12 12 0 0 0-2 4.1c-.5 1.7-.7 3.4-.7 5.2 0 1.3.3 2.7.8 3.9.5 1.1 1.3 2 2.4 2.6 1.1.6 2.3 1 3.5.9 2 0 3.9-.7 5.4-2 1.7-1.5 2.9-3.4 3.6-5.6h8.7c-.7 3-2 5.8-3.8 8.2A18.4 18.4 0 0 1 64 43.9zM106.2 43.2h8.9L109 8.6h-9.6L80.8 43.2h9.4l3.3-6.5h11.8l.9 6.5zM97 29.7l5.7-11.3 1.6 11.3H97zM132.9 43.2h-13.5l6.1-34.5h12.6c2.7-.1 5.3.6 7.7 1.8 2.2 1.2 4 2.9 5.2 5.1 1.3 2.3 2 4.9 1.9 7.5 0 2.8-.5 5.5-1.5 8.1a18.7 18.7 0 0 1-10.6 10.6 23 23 0 0 1-7.9 1.4zm0-26.9-3.5 19.1h4.2a12 12 0 0 0 4.2-.8 10 10 0 0 0 3.3-2.4c.9-1.1 1.7-2.4 2.1-3.8.5-1.6.7-3.3.7-5 0-1.3-.3-2.7-.9-3.8-.6-1-1.4-1.9-2.5-2.4a7.6 7.6 0 0 0-3.9-.8l-3.7-.1z" />
        </g>
        <path
          fill="url(#logo-gradient-x)"
          d="M14.8 49.8H0l18.2-25.7L9 0h13.3l6.3 17 11-17h15L36.1 25.1 46 49.8H32.5l-6.7-17.4-11 17.4z"
        />
      </symbol>
      <symbol id="icon-logo-x" viewBox="0 0 54.6 49.81">
        <path
          d="M14.85 49.81H0l18.25-25.67L8.95 0h13.32l6.31 17L39.62 0H54.6L36.08 25.12l9.85 24.7h-13.4L25.82 32.4Z"
          fill="url(#logo-gradient-x)"
        />
      </symbol>
      <symbol id="icon-play" viewBox="0 0 80 80">
        <path fill="url(#a)" d="M76.82 42.02 3 2v76.95l73.82-36.93Z" />
        <defs>
          <linearGradient
            id="a"
            x1="51.63"
            x2="-43.29"
            y1="81.33"
            y2="-1.96"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FD5C27" />
            <stop offset=".47" stopColor="#FC1557" />
            <stop offset="1" stopColor="#AC269A" />
          </linearGradient>
        </defs>
      </symbol>
      <defs>
        <linearGradient
          id="logo-gradient-x"
          x1="27.3"
          y1="49.81"
          x2="27.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fc7c21" />
          <stop offset=".5" stopColor="#fb1359" />
          <stop offset="1" stopColor="#7821a2" />
        </linearGradient>
      </defs>
    </svg>
  )
}

SVGDefs.defaultProps = {
  className: '',
}

SVGDefs.propTypes = {
  className: PropTypes.string,
}

export default SVGDefs
